<template>
  <header class="Heading">
    <section class="heading-top">
      <h1 class="heading-title">{{ $t('jobs_page.small_header') }}</h1>
      <h3 class="heading-subtitle">{{ $t('jobs_page.big_header') }}</h3>
    </section>
    <section class="image-wrapper">
      <div class="image-text-wrapper">
        <h4 class="image-title">{{ $t('jobs_page.header_one') }}</h4>
        <p class="image-text">
          {{ $t('jobs_page.body_one') }}
        </p>
      </div>
      <img class="heading-image" src="~@/assets/careers/careers-hero.webp" />
    </section>
  </header>
</template>

<script>
export default {};
</script>

<style scoped>
.Heading {
  height: auto;
  --subheading-f-size: 30px;
  --heading-title-f-size: 12px;
  --image-title-f-size: 30px;
  --image-text-f-size: 14px;
  --image-text-max-size: 80%;
  display: grid;
  --heading-grid-rows: calc(20vh - 38px) calc(50vh - 38px);
  grid-template-rows: var(--heading-grid-rows);
}
.heading-top {
  align-self: center;
}
.heading-title {
  color: #2b4047;
  font-weight: normal;
  font-size: var(--heading-title-f-size);
  text-align: center;
  text-transform: uppercase;
}

.heading-subtitle {
  color: #2b4047;
  font-size: var(--subheading-f-size);
  font-family: 'Foco';
  text-align: center;
}

.image-wrapper {
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
}
.image-text-wrapper {
  grid-row: 2;
  z-index: 2;
  grid-column: 1;
  color: white;
  justify-self: center;
  text-align: center;
  max-width: var(--image-text-max-size);
}
.image-title {
  font-size: var(--image-title-f-size);
  font-weight: bold;
  padding-bottom: 24px;
}
.image-text {
  font-size: var(--image-text-f-size);
}
.heading-image {
  height: 100%;
  width: 100%;
  grid-row: 1 / -1;
  grid-column: 1;
  object-fit: cover;
}
@media (min-width: 768px) {
  .Heading {
    --subheading-f-size: 60px;
    --heading-title-f-size: 14px;
    --image-title-f-size: 32px;
    --image-text-f-size: 18px;
    --heading-grid-rows: 35vh 45vh;
    --image-text-max-size: 50%;
  }
}
</style>
